import { Box, Flex, Text } from '@chakra-ui/react'
import { MouseEventHandler } from 'react'

import { ChevronRight } from '../../../../icons'
import { icons } from '../icons'

export const SectionTitle = ({
  label,
  icon,
  isOpened = false,
  bg,
  onClick,
}: {
  label?: React.ReactNode | string
  icon?: keyof typeof icons
  isOpened?: boolean
  bg?: string
  onClick?: MouseEventHandler<HTMLDivElement>
}) => {
  const isExpandable = !!onClick

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 2,
        p: 2,
        bg: bg || isExpandable ? 'gray.100' : 'gray.50',
        cursor: isExpandable ? 'pointer' : 'default',
        _hover: isExpandable ? { bg: 'gray.200' } : {},
      }}
      onClick={onClick && onClick}
    >
      <Box
        sx={{
          h: 5,
          transform: isOpened ? 'rotate(90deg)' : '',
          transformOrigin: 'center center',
          visibility: isExpandable ? 'visible' : 'hidden',
        }}
      >
        <ChevronRight width={3} height={3} />
      </Box>

      {icon && icons[icon]}

      {label && (
        <Flex sx={{ lineHeight: 5, fontWeight: 'medium', whiteSpace: 'nowrap', w: '100%' }}>{label}</Flex>
      )}
    </Box>
  )
}
